import { useSelector } from 'react-redux';

import { BaseIcon, BaseStatus } from 'bxcommon';
import ListViewWrapper from 'bxcommon/components/ListViewWrapper/ListViewWrapper';
import { api } from 'bxcommon/store/api';

import {
  useGetProspectusListQuery,
  useLazyGetProspectusListQuery,
} from '../../store/endpoints/prospectus.endpoints';
import { ProspectusHeader } from '../ProspectusHeader/ProspectusHeader';
import { SECURITY_TYPE } from '../../constants';

const removeFromProspectusesList = (caseId) => async (dispatch) => {
  await dispatch(api.endpoints.deleteProspectus.initiate(caseId));
};

export const ListView = () => {
  const userId = useSelector((state) => state.user.details.id);
  const hasGroup = useSelector((state) => state.user.details.group);

  // Refetch the unfiltered list every time the page is mounted (incl. nav back).
  useGetProspectusListQuery({}, { refetchOnMountOrArgChange: true });
  const [triggerSearch] = useLazyGetProspectusListQuery();

  const searchProspectusList = (search, query) => async () => {
    const result = await triggerSearch(search ? { search, query } : {});
    return result.data;
  };

  const labels = ['lastUpdate', 'caseId', 'status', 'description', 'issuerName', hasGroup ? 'ownership' : null, ''];

  return (
    <ProspectusHeader>
      <ListViewWrapper
        isProspectus
        labels={labels}
        editUrl={SECURITY_TYPE}
        detailsUrl={'details'}
        search={{ queryName: 'case_id', hydrateList: searchProspectusList, placeholder: 'list.labels.caseId' }}
        removeFromList={removeFromProspectusesList}
      >
        {(item) => (
          <>
            <td className="copy copy--color-dark" data-testid="list-status">
              <BaseStatus status={item.status} />
            </td>
            <td className="copy copy--color-dark" data-testid="list-name">
              {item.name}
            </td>
            <td className="copy copy--color-dark" data-testid="list-issuer-name">
              {item.issuer_name || (item.issuers ?? []).join(', ')}
            </td>
            {hasGroup && (
              <td className="copy copy--color-dark" data-testid="list-owner">
                {item.creator && item.creator.id === userId && <BaseIcon icon="yes" />}
              </td>
            )}
          </>
        )}
      </ListViewWrapper>
    </ProspectusHeader>
  );
};

export default ListView;
